export const PLUGIN_PORTAL_PAGE = Symbol.for('PLUGIN_PORTAL_PAGE')
export const PLUGIN_CONSOLE_PAGE = Symbol.for('PLUGIN_CONSOLE_PAGE')
export const PLUGIN_ERROR_PAGE = Symbol.for('PLUGIN_ERROR_PAGE')
export const PLUGIN_RBAC = Symbol.for('PLUGIN_RBAC')
export const PLUGIN_SYS_CONFIG = Symbol.for('PLUGIN_SYS_CONFIG')
export const PLUGIN_AUTH = Symbol.for('PLUGIN_AUTH')
export const PLUGIN_NOTICE = Symbol.for('PLUGIN_NOTICE')
export const PLUGIN_DICTIONARY = Symbol.for('PLUGIN_DICTIONARY')
export const PLUGIN_ACCOUNT_INFO = Symbol.for('PLUGIN_ACCOUNT_INFO')
